import React, { FC, ReactNode } from 'react'
import { CloseOutlined } from '@ant-design/icons'
import styles from './STRTablePage.module.scss'

interface STRBannerProps {
  icon?: ReactNode
  children: ReactNode
  onClose: () => void
  variant?: 'success' | 'info'
}

const STRBanner: FC<STRBannerProps> = ({ icon, children, onClose, variant = 'success' }) => (
  <div className={`${styles.banner} ${styles[`banner--${variant}`]}`}>
    {icon}
    {children}
    <CloseOutlined style={{ cursor: 'pointer', fontSize: 12, marginLeft: 8, color: '#00000073' }} onClick={onClose} />
  </div>
)

export default STRBanner
